import React from "react";

const LizBuysHomes = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://dbLizBuysHomes.livauto.com/reports.php?a1b2c-3d4e5f6g-789hijk-123lmn45-678opq"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="First Premier Lending Reports"
      ></iframe>
    </div>
  );
};

export default LizBuysHomes;
